import React, { useEffect, useState } from "react";
import {
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import InfoIcon from "@mui/icons-material/Info";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "app/pages/Component/Function/formatDate";
import { getAllDispatchOrders } from "app/redux/actions/OrderProcessing/Dispatch";
import ViewDispatchModel from "../../ViewDispatchModel";
import OutForDeliveryModal from "../../OutForDeliveryModal/OutForDeliveryModal";

export default function DispatchTable({
  orderType,
  deliveryStatus,
  page,
  setPage,
  search,
  filter,
  sort,
  setSort,
  sortBy,
  setSortBy,
}) {
  const dispathOrderData = useSelector(
    (state) => state?.dispatchReducer?.[orderType]
  );
  const { TotalPage } = useSelector((state) => state?.dispatchReducer);
  const [orderDetails, setOrderDetails] = useState({});
  const [showmodel, setshowmodel] = useState(false);
  const [outForDelivery, setOutForDelivery] = useState(false);
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.userReducer);
  const Permission = userData?.current_data?.role_id?.current_data?.permissions;

  const handleItemAction = (menuItem) => {
    switch (menuItem.action) {
      case "view_dispatch":
        setOrderDetails(menuItem?.data?.current_data);
        setshowmodel(true);
        break;
      case "outForDelivery":
        setOrderDetails(menuItem?.data);
        setOutForDelivery(true);
        break;
      default:
      // navigate(`/dashboard/users`);
    }
  };

  const handleSort = (property) => {
    setSort(sort == "asc" ? "desc" : "asc");
    setSortBy(property);
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow sx={{ bgcolor: "#7352C7", color: "white" }}>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "140px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() => handleSort("current_data.dispatch_no")}
                direction={sort}
                sx={{
                  color: "white",
                  width: "100%",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                Dispatch No
              </TableSortLabel>
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "200px",
                verticalAlign: "middle",
                color: "white",
              }}
            >
              Dispatch Generated Date
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "160px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() => handleSort("current_data.sales_order_no")}
                direction={sort}
                sx={{
                  color: "white",
                  width: "100%",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                Sales Order No
              </TableSortLabel>
            </TableCell>

            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
                color: "white",
              }}
            >
              Sales Order Date
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "170px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() => handleSort("current_data.order_no")}
                direction={sort}
                sx={{
                  color: "white",
                  width: "100%",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                Customer Name
              </TableSortLabel>
            </TableCell>

            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "140px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() =>
                  handleSort(
                    "current_data.customer_details.bill_to.address.city"
                  )
                }
                direction={sort}
                sx={{
                  color: "white",
                  width: "100%",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                City
              </TableSortLabel>
            </TableCell>

            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "140px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() =>
                  handleSort(
                    "current_data.customer_details.bill_to.address.state"
                  )
                }
                direction={sort}
                sx={{
                  color: "white",
                  width: "100%",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                State
              </TableSortLabel>
            </TableCell>

            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() => handleSort("current_data.total_weight")}
                direction={sort}
                sx={{
                  color: "white",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                Total Weight
              </TableSortLabel>
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() => handleSort("current_data.total_amount")}
                direction={sort}
                sx={{
                  color: "white",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                Totol Amount
              </TableSortLabel>
            </TableCell>

            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
                color: "white",
                position: "sticky",
                right: 0,
                zIndex: 1,
                bgcolor: "#7352C7",
                height: "58px",
              }}
            >
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dispathOrderData?.map((row, i) => {
            return (
              <TableRow key={row._id}>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {row?.current_data?.dispatch_no}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {formatDate(
                    row?.current_data?.tracking_date?.dispatch_generated_date
                  )}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {row?.current_data?.sales_order_no}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                    textTransform: "capitalize",
                  }}
                >
                  {formatDate(
                    row?.current_data?.tracking_date?.sales_order_date
                  )}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                    textTransform: "capitalize",
                  }}
                >
                  {row?.current_data?.customer_details?.customer_name}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                    textTransform: "capitalize",
                  }}
                >
                  {row?.current_data?.customer_details?.bill_to?.address?.city}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                    textTransform: "capitalize",
                  }}
                >
                  {row?.current_data?.customer_details?.bill_to?.address?.state}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {row?.current_data?.total_weight}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  ₹ {row?.current_data?.total_amount?.toFixed(2)}
                </TableCell>

                <TableCell
                  sx={{
                    textAlign: "left",
                    position: "sticky",
                    right: 0,
                    zIndex: 1,
                    bgcolor: "white",
                  }}
                >
                  <JumboDdMenu
                    icon={<MoreHorizIcon />}
                    menuItems={[
                      {
                        icon: <InfoIcon />,
                        title: "View Dispatch Details",
                        action: "view_dispatch",
                        data: row,
                        visibility: Permission?.["dispatch"]?.["view"],
                      },
                      {
                        icon: <AddIcon />,
                        title: "Out For Delivery",
                        action: "outForDelivery",
                        data: row,
                        visibility: Permission?.["dispatch"]?.["add"],
                      },
                    ].filter((ele) => ele.visibility == true)}
                    onClickCallback={handleItemAction}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      {showmodel && (
        <ViewDispatchModel
          open={showmodel}
          setOpen={setshowmodel}
          selectedRow={orderDetails}
          setSelectedRow={setOrderDetails}
          deliveryStatus={deliveryStatus}
        />
      )}

      {outForDelivery && (
        <OutForDeliveryModal
          open={outForDelivery}
          setOpen={setOutForDelivery}
          selectedRow={orderDetails}
          orderType={orderType}
          deliveryStatus={deliveryStatus}
        />
      )}

      <Pagination
        count={TotalPage || 1}
        page={page}
        onChange={handleChangePage}
        sx={{
          position: "sticky",
          bottom: 0,
          left: 0,
          p: 1,
          backgroundColor: "white",
          borderTop: "1px solid #ddd",
        }}
      />
    </TableContainer>
  );
}
